import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  openTickets: {},
  closedTickets: {},
  loading: false,
  anomalyOpenFilterSchema: {},
  anomalyClosedFilterSchema: {},
  anomalyDetails: {
    data: {},
    loading: false
  },
  actionLoading: false,
  rcaReasons: [],
  acitvityLogs: {
    data: [],
    loading: false
  }
};

const anomalyTrackerSlice = createSlice({
  name: 'anomalyTracker',
  initialState,
  reducers: {
    setAnomalyOpenTickets: (state, action) => {
      state.openTickets = action.payload;
    },
    setAnomalyClosedTickets: (state, action) => {
      state.closedTickets = action.payload;
    },
    setAnomalyTicketsLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAnomalyOpenFilterSchema: (state, action) => {
      state.anomalyOpenFilterSchema = action.payload;
    },
    setAnomalyClosedFilterSchema: (state, action) => {
      state.anomalyClosedFilterSchema = action.payload;
    },
    setSingleAnomalyDetails: (state, action) => {
      state.anomalyDetails.data = action.payload;
    },
    setSingleAnomalyDetailsLoading: (state, action) => {
      state.anomalyDetails.loading = action.payload;
    },
    setAnomalyActionLoading: (state, action) => {
      state.actionLoading = action.payload;
    },
    setRcaReasons: (state, action) => {
      state.rcaReasons = action.payload;
    },
    setActivityLogs: (state, action) => {
      state.acitvityLogs.data = action.payload;
    },
    setActivityLogsLoading: (state, action) => {
      state.acitvityLogs.loading = action.payload;
    }
  }
});

export const {
  setAnomalyOpenTickets,
  setAnomalyClosedTickets,
  setAnomalyTicketsLoading,
  setAnomalyOpenFilterSchema,
  setAnomalyClosedFilterSchema,
  setSingleAnomalyDetails,
  setSingleAnomalyDetailsLoading,
  setAnomalyActionLoading,
  setRcaReasons,
  setActivityLogs,
  setActivityLogsLoading
} = anomalyTrackerSlice.actions;

export default anomalyTrackerSlice.reducer;
